<template>
    <section class="container enquiry-form">
        <notice-component/>
        <el-row type="flex" justify="center">
            <el-col :lg="20" :md="20" :sm="20" :xs="22">
                <el-row>
                    <el-col :lg="24">
                        <div class="section-heading">
                            <h3>Product Details</h3>
                        </div>
                        <div class="product-details" v-if="singleProduct">
                            <el-row type="flex" align="middle">
                                <el-col :lg="4" :md="4" :sm="4" :xs="5">
                                    <div class="product-image">
                                        <img :src="image.image" :alt="singleProduct.name"/>
                                    </div>
                                </el-col>
                                <el-col :lg="16" :sm="18" :md="18" :xs="14">
                                    <div class="product-content">
                                        <router-link
                                                :to="{ name: 'product-details', path: { slug: singleProduct.slug } }"
                                        >
                                            <h3>{{ singleProduct.name }}</h3>
                                        </router-link>
                                        <p>{{ singleProduct.brand }}</p>
                                    </div>
                                </el-col>
                                <el-col :lg="4" :xs="5">
                                    <div class="product-price text-right">
                                        <p>{{ singleProduct.display_price_after_discount }}</p>
                                        <small>Shipping cost: <strong>{{ singleProduct.display_shipping_cost }}</strong></small>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row type="flex" justify="end">
                                <div class="product-price text-right">
                                    <p class="inline-block mr-5">Total Price: </p>
                                    <p class="inline-block">{{ singleProduct.total_price }}</p>
                                </div>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <div class="product-enquiry-form mt-20">
                    <el-row>
                        <el-col :lg="24" :xs="24">
                            <div class="section-heading">
                                <h3>Shipping Details</h3>
                            </div>
                            <el-alert v-if="success_message" :title="success_message" type="success" class="success-message">
                            </el-alert>
                            <el-form ref="form" :model="product_purchase" label-position="top">
                                <el-row :gutter="30">
                                    <el-col :md="8">
                                        <el-form-item>
                                            <el-input v-model="product_purchase.name" placeholder="Name"></el-input>
                                            <p
                                                    class="error"
                                                    v-if="getErrors && getErrors.name"
                                            >{{ getErrors.name }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8">
                                        <el-form-item>
                                            <el-input v-model="product_purchase.email" placeholder="Email"></el-input>
                                            <p
                                                    class="error"
                                                    v-if="getErrors && getErrors.email"
                                            >{{ getErrors.email }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8">
                                        <el-form-item>
                                            <el-input type="text" v-model="product_purchase.mobile"
                                                      :maxlength="9"
                                                      pattern="/d"
                                                      placeholder="+6412345678"></el-input>
                                            <p
                                                    class="error"
                                                    v-if="getErrors && getErrors.mobile"
                                            >{{ getErrors.mobile }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :md="24">
                                        <el-form-item>
                                            <el-input v-model="product_purchase.transaction_ref_no"
                                                      placeholder="Bank transaction Number"></el-input>
                                            <p class="error" v-if="getErrors && getErrors.transaction_ref_no">{{
                                                getErrors.transaction_ref_no }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :md="24">
                                        <el-form-item>
                                            <el-input
                                                    type="textarea"
                                                    :autosize="{ minRows: 5, maxRows: 4}"
                                                    placeholder="Shipping Address"
                                                    v-model="product_purchase.address"
                                            ></el-input>
                                            <p class="error" v-if="getErrors && getErrors.address">
                                                {{ getErrors.address }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-col :md="24">
                                    <el-form-item>
                                        <el-button
                                                type="primary"
                                                @click="onSubmit"
                                                :loading="loading"
                                                class="btn submit-btn"
                                        >Send
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-form>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </section>
</template>

<script>
    import LayoutDefault from "@/layouts/LayoutDefault";
    import progress from "nprogress";
    import {mapGetters} from "vuex";
    import NoticeComponent from "../components/shared/NoticeComponent";

    export default {
        data() {
            return {
                singleProduct: '',
                image: {},
                success_message: '',
                loading: false,
                product_purchase: {
                    product_id: "",
                    name: "",
                    email: "",
                    mobile: "",
                    address: "",
                    transaction_ref_no: ""
                }
            };
        },
        components: {
            NoticeComponent
        },
        computed: {
            ...mapGetters("products", ["getSingleProduct"]),
            ...mapGetters("errors", ["getErrors", "getMessage"]),
            slug() {
                return this.$route.params.slug;
            }
        },
        created() {
            this.$emit("update:layout", LayoutDefault);
            this.$root.$emit('closenav', false);
        },
        async mounted() {
            await this.fetchSingleProduct();
        },
        methods: {
            async fetchSingleProduct() {
                progress.start();
                await this.$store.dispatch("products/fetchSingleProduct", this.slug);
                progress.done();
                this.singleProduct = this.getSingleProduct;
                this.image = this.getSingleProduct.images[0];
            },
            async onSubmit() {
                let params = {
                    product_id: this.singleProduct.id,
                    name: this.product_purchase.name,
                    email: this.product_purchase.email,
                    mobile: this.product_purchase.mobile,
                    transaction_ref_no: this.product_purchase.transaction_ref_no,
                    address: this.product_purchase.address,
                };
                progress.start();
                this.loading = true;
                await this.$store.dispatch("purchase/order", params);
                this.loading = false;
                progress.done();
                if (this.getMessage) {
                    this.success_message = this.getMessage
                    this.product_purchase = {
                        name: "",
                        email: "",
                        mobile: "",
                        transaction_ref_no: "",
                        address: "",
                        price: "",
                    };
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .success-message {
        margin-bottom: 15px;
        color: black!important;
        text-align: center;
        font-weight: bold;
    }
    @media (max-width: 576px) and (min-width: 0px) {
        .enquiry-form .product-details .product-image img {
            width: 100% !important;
        }
    }

    .enquiry-form {
        padding: 1em 0 4rem 0;
        font-family: "Work Sans", sans-serif;

        .section-heading {
            margin-bottom: 15px;

            h3 {
                font-size: 28px;
                line-height: 31px;
                text-transform: uppercase;
                color: #11233f;
            }
        }

        .product-details {
            .product-image img {
                width: 120px;
            }

            .product-content {
                h3 {
                    font-size: 1.2em;
                    text-transform: uppercase;
                    color: #000000;
                    margin-bottom: 10px;
                }

                p {
                    font-size: 0.9em;
                    opacity: 0.8;
                    line-height: 170%;
                    color: #000000;
                }
            }

            .product-price {
                p {
                    font-weight: 500;
                    font-size: 24px;
                }
            }
        }

        .product-enquiry-form {
            input::placeholder {
                font-family: "Work Sans", sans-serif;
            }

            .submit-btn {
                background: #12ab0f;
                border-radius: 6px;
                float: right;
                padding: 12px 55px;
                font-style: normal;
                font-weight: bold;
                font-family: "Work Sans", sans-serif;
                outline: none;
            }
        }
    }

    @media (min-width: 0px) and (max-width: 576px) {
        .enquiry-form {
            padding: 2em 0;

            .product-enquiry-form {
                margin-top: 50px !important;
            }

            .section-heading {
                h3 {
                    font-size: 18px !important;
                }
            }

            .product-details {
                .el-row {
                    flex-wrap: wrap;
                }

                .product-image {
                    img {
                        width: 60px !important;
                    }
                }

                .product-content h3 {
                    font-size: 1em !important;
                }

                .product-price {
                    margin-top: 15px;
                    text-align: center;

                    p {
                        font-size: 1.4em !important;
                    }
                }
            }
        }
    }
</style>
